import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["state", "stateInput"]

    connect() {
    }

    copy_from_insured(e) {
        e.preventDefault();

        const fields = [
            'first_name', 'last_name', 'middle_name', 'common_name',
            'address', 'city', 'state', 'zip', 'birthday',
            'phone_cell', 'phone_home', 'phone_office', 'email', 'prefer_contact'
        ];

        const ins_prefix = 'client_insured_attributes_';
        const own_prefix = 'client_owner_attributes_';

        fields.forEach((fname) => {
            const insField = document.getElementById(ins_prefix + fname);
            const ownField = document.getElementById(own_prefix + fname);
            if (insField && ownField) {
                ownField.value = insField.value;
            }
        });

        // Handle State logic
        const stateSel = document.getElementById('client_insured_attributes_state');
        const stateOwnerSel = document.getElementById('client_owner_attributes_state');
        const inpOwner = document.getElementById('client_owner_attributes_state_other');

        if (stateSel && stateOwnerSel) {
            const lastOption = stateSel.options[stateSel.options.length - 1];
            if (stateSel.value === lastOption.value) {
                stateOwnerSel.value = stateSel.value;
                if (inpOwner) {
                    inpOwner.value = stateSel.value;
                    inpOwner.classList.remove('hidden');
                }
            } else {
                if (inpOwner) {
                    inpOwner.value = '';
                    inpOwner.classList.add('hidden');
                }
            }
        }

        // Handle Gender (Radio buttons)
        const selectedGender = document.querySelector('input[name="client[insured_attributes][gender]"]:checked');
        if (selectedGender) {
            const ownerGender = document.querySelector(`input[name="client[owner_attributes][gender]"][value="${selectedGender.value}"]`);
            if (ownerGender) ownerGender.checked = true;
        }

        // Update Flatpickr
        const birthdayInput = document.getElementById('client_owner_attributes_birthday');
        if (birthdayInput && birthdayInput._flatpickr) {
            const insBirthdayValue = document.getElementById('client_insured_attributes_birthday').value;
            birthdayInput._flatpickr.setDate(insBirthdayValue);
        }
    }

    next(e) {
        e.preventDefault();

        // Clean up any existing alerts
        this.element.querySelectorAll('.alert-success').forEach(el => el.remove());

        // Get the label from data-next (e.g., "Insured")
        const nextTabName = e.currentTarget.dataset.next;

        // Find the radio input by its aria-label and check it
        const nextTabTrigger = this.element.querySelector(`input[type="radio"].tab[aria-label="${nextTabName}"]`);

        if (nextTabTrigger) {
            nextTabTrigger.checked = true;
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }
}